
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'FeaturesSection',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
});
